import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiTablePaginationStyles = {
    styleOverrides: {
        root: {
            position: 'sticky',
            bottom: 0,
            zIndex: '2',
            [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                position: 'static',
            },
            '&.pagination-rounded': {
                '& .MuiTablePagination-toolbar': {
                    borderRadius: '20px',
                },
            },
            '&.pagination-rounded-bottom': {
                display: 'block',
                backgroundColor: Palette.gray.gray75,
                '& .MuiTablePagination-toolbar': {
                    borderRadius: '0 0 16px 16px',
                    [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                        borderRadius: '20px',
                        marginTop: '12px',
                    },
                },
            },
            '& .MuiTablePagination-toolbar': {
                backgroundColor: Palette.white,
                borderTop: `2px solid ${Palette.gray.gray75}`,
                minWidth: '100%',
                justifyContent: 'space-between',
                padding: '16px',
            },
            '& .MuiTablePagination-input': {
                marginRight: 'auto',
                '& .MuiSelect-select': {
                    border: `2px solid ${Palette.gray.gray200}`,
                    borderRadius: '12px',
                    lineHeight: '29px',
                    minWidth: '46px !important',
                    textAlignLast: 'left',
                    paddingLeft: '16px',
                    fontSize: '14px',
                },
                '& .MuiSelect-icon': {
                    right: '16px',
                    top: 'calc(50% - 2px)',
                },
            },
            '& .MuiTablePagination-actions': {
                order: 2,
                '& .MuiButtonBase-root, .MuiPaginationItem-root': {
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 1L1 4L4 7' stroke='%231A1A1A' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M9 4L2 4' stroke='%231A1A1A' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    borderRadius: '12px',
                    width: '36px',
                    height: '36px',
                    backgroundColor: Palette.gray.gray100,
                    margin: '0 8px',
                    '&:hover': {
                        boxShadow: `inset 0 0 0 2px ${Palette.gray.gray300}`,
                    },
                    '& svg': {
                        display: 'none',
                    },
                    '&:last-of-type': {
                        transform: 'rotate(180deg)',
                        marginRight: 0,
                    },
                },
                '& .MuiButtonBase-root.Mui-disabled': {
                    opacity: 0.4,
                },
                '&:first-of-type': {
                    transform: 'rotate(180deg)',
                },
                '& .MuiPagination-ul': {
                    '& li': {
                        display: 'none',
                        '&:first-of-type': {
                            transform: 'rotate(180deg)',
                        },
                    },
                    '& li:first-of-type, & li:last-of-type': {
                        display: 'block',
                    },
                },
            },
            '& .MuiTablePagination-selectLabel': {
                margin: '0',
                fontSize: '14px',
                lineHeight: '20px',
                paddingRight: '4px',
            },
            '& .MuiTablePagination-displayedRows': {
                fontWeight: '500',
                fontSize: '14px',
                lineHeight: '20px',
            },
            '& .MuiTablePagination-spacer': {
                display: 'none',
            },
        },
    },
};
